import { Directive, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[rmsNgSelectEditFocused]',
    standalone: false
})
export class NgSelectEditFocusedDirective implements OnInit, OnDestroy {
  private static comboBoxSelector = `input[role='combobox']`;
  private static className = 'ng-select-edit-focused';

  private subscriptions: Array<Subscription> = [];

  constructor(private ngSelect: NgSelectComponent, private render: Renderer2) { }

  ngOnInit() {
    this.render.addClass(
      this.ngSelect.element,
      NgSelectEditFocusedDirective.className
    );
    this.subscriptions = [
      this.ngSelect.blurEvent.subscribe((evt: any) => this.onBlur(evt)),
      this.ngSelect.changeEvent.subscribe((evt: any) => this.onChange(evt)),
      this.ngSelect.focusEvent.subscribe((evt: any) => this.onFocus(evt)),
      this.ngSelect.clearEvent.subscribe((evt: any) => this.onClear(evt))
    ];
  }
  ngOnDestroy() {
    this.render.removeClass(
      this.ngSelect.element,
      NgSelectEditFocusedDirective.className
    );
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getComboBox(): HTMLInputElement {
    return this.ngSelect.element.querySelector(
      NgSelectEditFocusedDirective.comboBoxSelector
    );
  }

  onFocus($event: any) {
    const comboBox = this.getComboBox();
    if (comboBox && this.ngSelect.selectedItems.length) {
      comboBox.value = this.ngSelect.selectedItems[0].label;
    }
  }

  onChange($event: any) {
    const comboBox = this.getComboBox();
    if (comboBox && this.ngSelect.selectedItems.length) {
      setTimeout(() => {
        comboBox.value = this.ngSelect.selectedItems[0].label;
      }, 0);
    }
  }

  onClear($event: any) {
    const comboBox = this.getComboBox();
    if (comboBox) {
      comboBox.value = '';
      comboBox.blur();
    }
  }

  onBlur($event: any) {
    const comboBox = this.getComboBox();
    if (comboBox) {
      comboBox.value = '';
    }
  }
}
